import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import axios from "axios";
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import { setProducts } from "./store/slices/product-slice"
import 'animate.css';
import 'swiper/swiper-bundle.min.css';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./i18n";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

axios
  .get(`${API_URL}/products`)
  .then(({ data }) => store.dispatch(setProducts(data.products)))
  .catch((err) => console.error("Failed to load products", err));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
      <PersistProvider>
        <App />
      </PersistProvider>
    </Provider>
);

